// **Ein „Prüfen"-Knopf** mit seinem Ergebnis darunter. Wer erst speichern muss
// (Anmeldung, Modelle: die Probe liest, was gespeichert ist), tut das in `run`.

import { useState, type MouseEvent } from "react";
import type { ProbeResult } from "../../api/types";
import { checkText } from "../../lib/labels";
import { Note } from "../../ui/badge";

type Out = { kind: "pending" } | { kind: "result"; res: ProbeResult } | { kind: "error"; message: string };

/** Das Ergebnis einer Probe als Notiz — beim Gateway mit den ersten 30 Modellen. */
export function ProbeNote({ res }: { res: ProbeResult }) {
  const text = checkText(res.code) + (res.detail ? ` — ${res.detail}` : "");
  const models = res.data?.models;
  return (
    <Note tone={res.ok ? "ok" : "error"}>
      {text}
      {models && <><br /><span className="pf-sub">{models.length} Modelle: {models.slice(0, 30).join(", ")}{models.length > 30 ? " …" : ""}</span></>}
    </Note>
  );
}

export function Probe({ label, outId, run }: { label: string; outId: string; run: () => Promise<ProbeResult> }) {
  const [busy, setBusy] = useState(false);
  const [out, setOut] = useState<Out | null>(null);
  const click = async (e: MouseEvent) => {
    e.preventDefault();
    setBusy(true);
    setOut({ kind: "pending" });
    try {
      setOut({ kind: "result", res: await run() });
    } catch (err) {
      setOut({ kind: "error", message: err instanceof Error ? err.message : String(err) });
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <div className="pf-row"><button type="button" className="pf-btn pf-btn--sm" disabled={busy} onClick={click}>{label}</button></div>
      <div id={outId}>
        {out?.kind === "pending" && <Note>Wird geprüft …</Note>}
        {out?.kind === "result" && <ProbeNote res={out.res} />}
        {out?.kind === "error" && <Note tone="error">{out.message}</Note>}
      </div>
    </>
  );
}
